import React, { Component } from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';

import { actionCreators as UtilityActions } from 'redux/utility/actions';
import { ROUTES } from 'constants/routes';

import { gaTrackPageView } from '../../../../../services/AnalyticsService';

import ComplaintsScene from './layout';
import styles from './styles';

class ComplaintSceneContainer extends Component {
  componentDidMount() {
    if (this.props.isPublic) gaTrackPageView(ROUTES.PUBLIC_COMPLAINTS);
    else gaTrackPageView(ROUTES.COMPLAINTS);
  }

  handleAddComplaint = async () => {
    await this.props.dispatch(UtilityActions.getComplaintForm());
    const route = this.props.isPublic ? ROUTES.PUBLIC_NEW_COMPLAINT : ROUTES.NEW_COMPLAINT;
    this.props.dispatch(push(route));
  };

  render() {
    return (
      <div style={styles.container}>
        <ComplaintsScene onAddComplaint={this.handleAddComplaint} />
      </div>
    );
  }
}

ComplaintSceneContainer.propTypes = {
  isPublic: PropTypes.bool
};

const mapStateToProps = store => ({
  complaintForm: store.utility.complaintForm,
  complaintFormLoading: store.utility.complaintFormLoading
});

export default connect(mapStateToProps)(Radium(ComplaintSceneContainer));
